export class Cargo {
    id: number;
    nome: string;
    ativo: boolean = true;
}
